import { useTranslation } from 'react-i18next'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import MyLocationOutlinedIcon from '@mui/icons-material/MyLocationOutlined'
import LocalPostOfficeOutlinedIcon from '@mui/icons-material/LocalPostOfficeOutlined'

import GooglePlacesAutocompleteField from '@/components/formik/fields/GooglePlacesAutocompleteField'
import TextField from '@/components/formik/fields/TextField'
import WeeklyScheduleBuilder from '../components/WeeklyScheduleBuilder'

export default function ServiceAreaScheduleStep() {
  const { t } = useTranslation()

  return (
    <Stack spacing={3}>
      <Stack spacing={0.5}>
        <Typography variant="h6">
          {t('page.meetingLink.wizard.serviceArea.title', 'Where do you travel?')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('page.meetingLink.wizard.serviceArea.subtitle', 'Define your service area and schedule')}
        </Typography>
      </Stack>

      <Alert severity="info" variant="outlined">
        {t('page.meetingLink.wizard.serviceArea.info', 'Patients within your service area can request home visits. You\'ll see their address before accepting.')}
      </Alert>

      {/* Option 1: Postal codes */}
      <Box sx={{ p: 2, pb: 1, border: '1px solid', borderColor: 'divider', borderRadius: 2, bgcolor: 'grey.50' }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }} flexWrap="wrap">
          <LocalPostOfficeOutlinedIcon color="primary" fontSize="small" />
          <Typography variant="subtitle2">
            {t('page.meetingLink.wizard.serviceArea.postalCodesLabel', 'By postal codes')}
          </Typography>
          <Chip label={t('page.meetingLink.wizard.serviceArea.option', 'Option 1')} size="small" variant="outlined" />
        </Stack>
        <TextField
          fullWidth
          multiline
          minRows={1}
          maxRows={3}
          label={t('field.serviceArea.postalCodes')}
          name="serviceArea.allowedPostalCodes"
          placeholder={t('field.serviceArea.postalCodesPlaceholder')}
          helperText={t('field.serviceArea.postalCodesHelp')}
          size="small"
        />
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 0 }}>
        {t('page.meetingLink.wizard.serviceArea.or', '— or —')}
      </Typography>

      {/* Option 2: Radius from center */}
      <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2, bgcolor: 'grey.50' }}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
          <MyLocationOutlinedIcon color="primary" fontSize="small" />
          <Typography variant="subtitle2">
            {t('page.meetingLink.wizard.serviceArea.radiusLabel', 'By radius')}
          </Typography>
          <Chip label={t('page.meetingLink.wizard.serviceArea.option2', 'Option 2')} size="small" variant="outlined" />
        </Stack>
        <Stack spacing={2}>
          <GooglePlacesAutocompleteField
            label={t('field.serviceArea.center')}
            name="serviceArea.center"
          />
          <TextField
            fullWidth
            label={t('field.serviceArea.radius')}
            name="serviceArea.radiusKm"
            type="number"
            inputProps={{ min: 1, inputMode: 'numeric' }}
            size="small"
          />
        </Stack>
      </Box>

      <Divider />

      <Typography variant="subtitle2">
        {t('page.meetingLink.wizard.serviceArea.scheduleLabel', 'Weekly schedule')}
      </Typography>

      <WeeklyScheduleBuilder />
    </Stack>
  )
}
